<template>
    <video id="azuremediaplayer" ref="digivideo" class="azuremediaplayer amp-default-skin amp-big-play-centered" tabindex="0"></video>
</template>

<script>
    export default {
        name: "design-2021-digistudies-example-video-component",
        props: ['video', 'token'],
        mounted() {
            const myOptions = {
                autoplay: true,
                controls: true,
                fluid: true,
                poster: this.video.thumbnail_url
            };
            const myPlayer = amp('azuremediaplayer', myOptions);
            myPlayer.src([
                {
                    src: this.video.stream_url,
                    streamingFormats: ['DASH', 'SMOOTH'],
                    type: "application/vnd.ms-sstr+xml",
                    protectionInfo: [
                        {type: "AES", authenticationToken: 'Bearer=' +this.token}
                    ]
                },
                {
                    src: 'https://digistudies.azurewebsites.net/v1/videos/hls-load/' + this.video.id + '?token=' + this.token,
                    type: 'application/vnd.apple.mpegurl',
                    streamingFormats: [
                        'HLS-V4',
                        'HLS-V3',
                    ],
                }

            ]);
        },

    }
</script>

<style scoped>

</style>
